// An item's picture, used by the store pages and by the admin package cards: its own image when staff set one, otherwise a
// plate in the colour of its kind (gold for ranks, sky for keys, neutral for perks), deeper for higher ranks.
import type { CSSProperties } from "react";
import { Icon } from "../../icons";
import type { StoreItem } from "./storeSite";
import { artKind, tileOf } from "./storeText";

type Artful = { icon: string | null; type: string | null; imageUrl: string | null; rank?: StoreItem["rank"] };

export function ItemArt({ item, size = "card" }: { item: Artful; size?: "card" | "wide" | "tile" }) {
  if (item.imageUrl) return <span className={`item-art has-image ${size}`}><img src={item.imageUrl} alt="" width={640} height={400} loading="lazy"/></span>;
  const tile = tileOf(item.icon, item.type);
  const tier = item.rank ? item.rank.position / Math.max(item.rank.of, 1) : 0.4;
  return <span className={`item-art kind-${artKind(item.type)} ${size}`} style={{ "--tier": tier.toFixed(2) } as CSSProperties} aria-hidden="true">
    <span className="item-art-glyph">{"name" in tile ? <Icon name={tile.name} size={size === "tile" ? 26 : 36}/> : <span className="store-tile-text">{tile.text}</span>}</span>
  </span>;
}
